import { render, staticRenderFns } from "./life-bank-order-message.vue?vue&type=template&id=c7ca60d4&"
import script from "./life-bank-order-message.vue?vue&type=script&lang=js&"
export * from "./life-bank-order-message.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports